module.exports = __webpack_public_path__ + "static/img/blue-3.3598e1e5.jpg";